import { withInstall } from '@antdv/utils';
import ARate from './src/Rate';

export const Rate = withInstall(ARate);

export default Rate;

export * from './src/props';
